import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { MainService } from "../../../../app.service";
import { GiteaRepo } from "../../interfaces/gitea-repo";
import { Response } from "../../interfaces/response";
import { GiteaPermission } from "../../interfaces/gitea-permission";
import { GiteaUser } from "../../interfaces/gitea-user";
import { GiteaReposContent } from "../../interfaces/gitea-repos-content";
import { GiteaReposPull } from "../../interfaces/gitea-repos-pull";
import { GiteaReposPullState } from "../../enums/gitea-repos-pull-states";

@Injectable({
  providedIn: "root",
})
export class DependencyTrackGiteaService {
  constructor(
    private httpClient: HttpClient,
    private mainsService: MainService
  ) {}

  getGiteaReposSearch(
    userId: string,
    page: number,
    limit: number
  ): Observable<Response<GiteaRepo>> {
    return this.httpClient.get<Response<GiteaRepo>>(
      `/dependency-tracker-extractor/v1/gitea/repos/search`,
      {
        params: { user_id: userId, page, limit },
        ...this.mainsService.httpOptions,
      }
    );
  }

  putGiteaReposCollaborators(
    repo: string,
    collaborator: string,
    permission: GiteaPermission
  ): Observable<void> {
    return this.httpClient.put<void>(
      `/dependency-tracker-extractor/v1/gitea/repos/${repo}/collaborators/${collaborator}`,
      permission,
      this.mainsService.httpOptions
    );
  }

  getGiteaReposContents(repo: string, branch: string): Observable<void> {
    return this.httpClient.get<void>(
      `/dependency-tracker-extractor/v1/gitea/repos/${repo}/contents`,
      { params: { branch }, ...this.mainsService.httpOptions }
    );
  }

  postGiteaReposContents(
    repo: string,
    branch: string
  ): Observable<HttpResponse<Array<GiteaReposContent>>> {
    return this.httpClient.post<Array<GiteaReposContent>>(
      `/dependency-tracker-extractor/v1/gitea/repos/${repo}/contents`,
      { branch },
      {
        ...this.mainsService.httpOptions,
        observe: 'response'
      }
    );
  }

  postGiteaReposPulls(
    repo: string,
    branch: string
  ): Observable<GiteaReposPull> {
    return this.httpClient.post<GiteaReposPull>(
      `/dependency-tracker-extractor/v1/gitea/repos/${repo}/pulls`,
      { branch },
      this.mainsService.httpOptions
    );
  }

  patchGiteaReposPulls(
    repo: string,
    pullRequestId: string,
    state: GiteaReposPullState
  ): Observable<GiteaReposPull> {
    return this.httpClient.patch<GiteaReposPull>(
      `/dependency-tracker-extractor/v1/gitea/repos/${repo}/pulls/${pullRequestId}`,
      { state },
      this.mainsService.httpOptions
    );
  }

  getGiteaUsers(): Observable<GiteaUser> {
    return this.httpClient.get<GiteaUser>(
      `/dependency-tracker-extractor/v1/gitea/users`,
      this.mainsService.httpOptions
    );
  }

  deleteGiteaReposBranch(repo: string, branch: string): Observable<void> {
    return this.httpClient.delete<void>(
      `/dependency-tracker-extractor/v1/gitea/repos/${repo}/branches/${branch}`,
      this.mainsService.httpOptions
    );
  }
}
